export default __webpack_public_path__ + "static/955-bb198abc385a972322112b95e349eac5.gif";